import { render } from "./SimFassetLogoLrg.vue?vue&type=template&id=5cb2e9ef&scoped=true"
const script = {}

import "./SimFassetLogoLrg.vue?vue&type=style&index=0&id=5cb2e9ef&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb2e9ef"]])

export default __exports__